// extracted by mini-css-extract-plugin
export default {"footerStyling":"confirmation-modal_footerStyling__chdzH","confirmationModalHeader":"confirmation-modal_confirmationModalHeader__Wb18X"};